import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function RequirePlatformPermission({ permission, children }) {
  const { sessionLoading, hasPlatformAccess, hasPlatformPermission } = useAuth();

  if (sessionLoading) {
    return <div className="loading-state">Loading…</div>;
  }

  if (!hasPlatformAccess) {
    return <Navigate to="/console" replace />;
  }

  if (permission && !hasPlatformPermission(permission)) {
    return <Navigate to="/platform" replace />;
  }

  return children || <Outlet />;
}

export default RequirePlatformPermission;
